import { render, staticRenderFns } from "./zk.vue?vue&type=template&id=f4bb8fe8&scoped=true"
import script from "./zk.vue?vue&type=script&lang=js"
export * from "./zk.vue?vue&type=script&lang=js"
import style0 from "./zk.vue?vue&type=style&index=0&id=f4bb8fe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bb8fe8",
  null
  
)

export default component.exports